import httpService from '@/core/http-service'

function getErrands(propertyManagerId, filterSearch = '*', filterStatus = '*', filterWorkType = '*', pageSize = 10, currentPage = 1, sortByOrder = 'asc', sortBy = 'request_id', cacheBust, channel, accessGroup) {
  const params = { propertyManagerId, filterSearch, filterStatus, filterWorkType, pageSize, currentPage, sortByOrder, sortBy, channel, accessGroup, cacheBust }
  return httpService.get(`errands`, params)
}

function getErrand(requestId) {
  return httpService.get(`errands/${requestId}`)
}

function getTasks(requestId) {
  return httpService.get(`errands/${requestId}/tasks`)
}

function getAttachments(requestId) {
  return httpService.get(`errands/${requestId}/attachments`)
}

function getEvents(requestId) {
  return httpService.get(`errands/${requestId}/events`)
}

function getHistory(requestId) {
  return httpService.get(`errands/${requestId}/history`)
}

function getPolygonEmployee(polygonId) {
  return httpService.get(`polygonemployee/${polygonId}`)
}

function postNewAttachments(requestId, attachments) {
  return httpService.uploadFiles(`errands/${requestId}/attachments`, attachments)
}

function getMembers(requestId) {
  return httpService.get(`errands/${requestId}/members`)
}

export default { getPolygonEmployee, getErrands, getErrand, getTasks, getAttachments, getEvents, getHistory, postNewAttachments, getMembers }
